// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__NKduT","resendInfoText":"OnGoingPaymentBox_resendInfoText__2KD4C"};